import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withKeys as _withKeys, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "p-0 p-md-" }
const _hoisted_2 = { class: "text-center mb-5" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = {
  key: 0,
  class: "text-gray-900 mb-5"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "h1 fw-semobold fs-4 d-none" }, " Inicio de sesión ", -1)
const _hoisted_6 = { class: "fv-row mb-10" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bold text-dark" }, "Usuario", -1)
const _hoisted_8 = { class: "fv-row mb-5" }
const _hoisted_9 = { class: "d-flex flex-stack mb-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold text-dark fs-6 mb-0" }, "Contraseña", -1)
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Ingresar ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Validando... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = {
  class: "alert alert-light-info text-gray-600 bg-light mb-0",
  role: "alert"
}
const _hoisted_16 = {
  key: 0,
  class: "text-center my-5"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "¿Aún no tienes cuenta?", -1)
const _hoisted_18 = {
  key: 1,
  class: ""
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h1", null, "No se encontró información disponible para el inicio de sesión con su compañia seleccionada.", -1)
const _hoisted_20 = [
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.dataCompany?.idcompany)
      ? (_openBlock(), _createBlock(_component_el_form, {
          key: 0,
          ref: "ruleFormRef",
          model: _ctx.form,
          rules: _ctx.rules,
          class: "form w-100"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("img", {
                src: `${_ctx.repo}/${_ctx.dataCompany?.avatars?.login}`,
                alt: _ctx.dataCompany.name,
                class: "h-100px mb-4"
              }, null, 8, _hoisted_3),
              (_ctx.dataCompany?.setting?.title?.visible)
                ? (_openBlock(), _createElementBlock("h1", _hoisted_4, _toDisplayString(_ctx.dataCompany?.name), 1))
                : _createCommentVNode("", true),
              _hoisted_5
            ]),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_el_form_item, { prop: "username" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.username,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.username) = $event)),
                    "prefix-icon": _ctx.User,
                    size: "large",
                    placeholder: "Usuario",
                    maxlength: "50"
                  }, null, 8, ["modelValue", "prefix-icon"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_router_link, {
                  to: "register",
                  class: "link-primary fs-6 fw-bold d-none"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Recuperar contraseña ? ")
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_el_form_item, { prop: "password" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.password,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.password) = $event)),
                    "prefix-icon": _ctx.Key,
                    onKeypress: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.onSubmitLogin(_ctx.ruleFormRef)), ["enter"])),
                    "show-password": "true",
                    size: "large",
                    placeholder: "Contraseña",
                    maxlength: "30"
                  }, null, 8, ["modelValue", "prefix-icon"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                type: "button",
                ref: "submitButton",
                class: "btn btn-lg btn-primary w-100 my-5",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSubmitLogin(_ctx.ruleFormRef)))
              }, _hoisted_14, 512),
              _createElementVNode("div", _hoisted_15, [
                _createTextVNode(" Ante cualquier inconveniente técnico, comuníquese a: "),
                _createElementVNode("b", null, _toDisplayString(_ctx.emailSupport), 1)
              ])
            ]),
            (_ctx.dataCompany?.register_clubs == '1')
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _hoisted_17,
                  _createVNode(_component_router_link, {
                    to: "register",
                    class: "link-primary fs-6 fw-bold"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Regístrate aquí ")
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["model", "rules"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
  ])), [
    [_directive_loading, _ctx.loading]
  ])
}